import { axiosInstance } from '../../../services/api';
import { OpusSource } from '../domain/models';

export interface OpusFileOption { key: string; name: string; size: number; lastModified: string | null; duplicateCount: number; }

export async function fetchOpusFiles(): Promise<OpusFileOption[]> {
  const response = await axiosInstance.get<{ success: boolean; files: OpusFileOption[]; message?: string }>('/api/opus/files');
  if (!response.data.success) throw new Error(response.data.message || 'Unable to list OPUS files');
  return response.data.files;
}

export async function fetchOpusSource(key: string, runId: OpusSource['runId']): Promise<OpusSource> {
  // Reuse the established content proxy: it creates and consumes a presigned
  // S3 URL inside the Worker, avoiding both browser CORS and direct GetObject
  // incompatibilities in the Worker runtime.
  const response = await axiosInstance.get<string>('/api/content', { params: { key }, responseType: 'text' });
  if (!response.data) throw new Error('Selected OPUS source is empty');
  return { key, filename: key.split('/').pop() || key, text: response.data, runId };
}
